import { apiV2AssertError } from "~/hooks/api/v2/apiV2Request";

/**
 * Check if an error is a postcode conflict error
 */
export const isPostcodeConflictError = (error: unknown): boolean => {
  const apiError = apiV2AssertError(error);
  const message = apiError?.response?.data.message ?? "";
  return message.includes("Postcode component overlap");
};
